import { render, staticRenderFns } from "./PaperList.vue?vue&type=template&id=5ee6ecfe&scoped=true"
import script from "./PaperList.vue?vue&type=script&lang=js"
export * from "./PaperList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee6ecfe",
  null
  
)

export default component.exports